:host {
  display: none;
  position: fixed;
  right: 0;
  top: 200px;
  z-index: $z-index-toolbar;
  width: 45px;

  @include breakpoint($medium) {
    display: block;
  }

  nav {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
}
